<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Surat Jalan Supply For Subcontract" active>

                                <b-row v-if="hasFailedDataSuratJalanSupplyForSubcontract">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSuratJalanSupplyForSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanSupplyForSubcontractsFailed" :fields="fieldsSuratJalanSupplyForSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanSupplyForSubcontract" :sort-desc.sync="sortDescSuratJalanSupplyForSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSuratJalanSupplyForSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanSupplyForSubcontracts" :fields="fieldsSuratJalanSupplyForSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanSupplyForSubcontract" :sort-desc.sync="sortDescSuratJalanSupplyForSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Surat Jalan Supply For Subcontract Detail" active>

                                <b-row v-if="hasFailedDataSuratJalanSupplyForSubcontractDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSuratJalanSupplyForSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanSupplyForSubcontractDetailsFailed" :fields="fieldsSuratJalanSupplyForSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanSupplyForSubcontractDetail" :sort-desc.sync="sortDescSuratJalanSupplyForSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(orderQty)="row">
													{{ Number(row.item.orderQty).toLocaleString() }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSuratJalanSupplyForSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanSupplyForSubcontractDetails" :fields="fieldsSuratJalanSupplyForSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanSupplyForSubcontractDetail" :sort-desc.sync="sortDescSuratJalanSupplyForSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(orderQty)="row">
													{{ Number(row.item.orderQty).toLocaleString() }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import SuratJalanSupplyForSubcontract from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontract';
import SuratJalanSupplyForSubcontractList from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractList';
import SuratJalanSupplyForSubcontractFilter from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsSuratJalanSupplyForSubcontract: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Material Issue Number (W/O No)", key: 'workOrderSupplySubcontractMaterialIssueNumber', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "IsAlreadyDelivered", key: 'isAlreadyDelivered', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order", key: 'purchaseOrderPurchaseOrderNumber', sortable: false},
				{"class" : "th-status", "label" : "Vendor", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "Driver Name", key: 'driverName', sortable: false},
				{"class" : "th-status", "label" : "Vehicle Number", key: 'vehicleNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsSuratJalanSupplyForSubcontractDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Order Qty", key: 'orderQty', sortable: false},
				{"class" : "th-status", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false},
				{"class" : "th-status", "label" : "WO Supply Detail", key: 'workOrderSupplySubcontractDetailPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			suratJalanSupplyForSubcontracts : [],
			suratJalanSupplyForSubcontractsFailed: [],
			suratJalanSupplyForSubcontractId : '',
			sortBySuratJalanSupplyForSubcontract: '',
			sortDescSuratJalanSupplyForSubcontract: '',
			hasFailedDataSuratJalanSupplyForSubcontract: false,
			totalFailedSuratJalanSupplyForSubcontract: 0,
			totalSucceedSuratJalanSupplyForSubcontract: 0,
			suratJalanSupplyForSubcontractDetails : [],
			suratJalanSupplyForSubcontractDetailsFailed: [],
			suratJalanSupplyForSubcontractDetailId : '',
			sortBySuratJalanSupplyForSubcontractDetail: '',
			sortDescSuratJalanSupplyForSubcontractDetail: '',
			hasFailedDataSuratJalanSupplyForSubcontractDetail: false,
			totalFailedSuratJalanSupplyForSubcontractDetail: 0,
			totalSucceedSuratJalanSupplyForSubcontractDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('suratjalansupplyforsubcontract/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('suratjalansupplyforsubcontract/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getSuratJalanSupplyForSubcontractForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getSuratJalanSupplyForSubcontractForUpload : async function() {
			let _this = this;
			this.$http.get('suratjalansupplyforsubcontract/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.suratJalanSupplyForSubcontracts = [];
_this.suratJalanSupplyForSubcontractDetails = [];


					if (response != null) {
						let result = response.data;
						_this.suratJalanSupplyForSubcontracts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedSuratJalanSupplyForSubcontract = _this.suratJalanSupplyForSubcontracts.length;

						_this.suratJalanSupplyForSubcontractsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataSuratJalanSupplyForSubcontract = true;
						_this.totalFailedSuratJalanSupplyForSubcontract = 0;
						if(_this.suratJalanSupplyForSubcontractsFailed == undefined || _this.suratJalanSupplyForSubcontractsFailed.length === 0) _this.hasFailedDataSuratJalanSupplyForSubcontract = false;
						if(_this.hasFailedDataSuratJalanSupplyForSubcontract) _this.totalFailedSuratJalanSupplyForSubcontract = _this.suratJalanSupplyForSubcontractsFailed.length;
						_this.suratJalanSupplyForSubcontractDetails = [];
						_this.suratJalanSupplyForSubcontractDetailsFailed = [];
						_this.hasFailedDataSuratJalanSupplyForSubcontractDetail = true;
						_this.totalSucceedSuratJalanSupplyForSubcontractDetail = 0;
						result.forEach(function(element) {
							_this.suratJalanSupplyForSubcontractDetails.push(...element.suratJalanSupplyForSubcontractDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedSuratJalanSupplyForSubcontractDetail = _this.suratJalanSupplyForSubcontractDetails.length;

							_this.suratJalanSupplyForSubcontractDetailsFailed.push(...element.suratJalanSupplyForSubcontractDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.suratJalanSupplyForSubcontractDetailsFailed == undefined || _this.suratJalanSupplyForSubcontractDetailsFailed.length === 0) _this.hasFailedDataSuratJalanSupplyForSubcontractDetail = false;
							if(_this.hasFailedDataSuratJalanSupplyForSubcontractDetail) _this.totalFailedSuratJalanSupplyForSubcontractDetail = _this.suratJalanSupplyForSubcontractDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'suratjalansupplyforsubcontract/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'SuratJalanSupplyForSubcontract.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterSuratJalanSupplyForSubcontract = new SuratJalanSupplyForSubcontractFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
